module.exports = __webpack_public_path__ + "img/DealsMoney.3c8dd394.svg";